import * as React from 'react';

import Checkmark from 'src/images/checkmark.svg?noAttrs';

import css from './done.css';


const Done = ({
  color,
  children,
}: {
  color?: string;
  children?: React.ReactNode;
}): React.ReactElement<React.ComponentProps<'div'>> => (
  <div className={css.container}>
    <div className={css.messageBox}>
      {/* @ts-expect-error - TS2322 - Type '{ style: { fill: string | undefined; }; }' is not assignable to type 'IntrinsicAttributes'. */}
      <Checkmark style={{fill: color}} />
      <div className={css.message}>Thank you.</div>
      {children}
    </div>
  </div>
);

export default Done;
